import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=5ae8c60a&"
import script from "./Specialties.vue?vue&type=script&lang=ts&"
export * from "./Specialties.vue?vue&type=script&lang=ts&"
import style0 from "./Specialties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports